import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import { ImageIcon } from "../../themeV2";
import css from "./ProductThumbnail.module.css";

const ProductThumbnail = React.forwardRef(
  (
    {
      src,
      alt,
      inset = false,
      aspectRatio = "1/1",
      className,
      children,
      ...rest
    },
    ref,
  ) => {
    const [imgError, setImgError] = React.useState(false);

    React.useEffect(() => {
      setImgError(false);
    }, [src]);

    const showImage = src && !imgError;
    const modeClass = inset ? css.inset : css.cover;

    return (
      <div
        ref={ref}
        className={clsx(css.root, modeClass, className)}
        style={{ aspectRatio }}
        {...rest}
      >
        {showImage ? (
          <img
            className={css.image}
            src={src}
            alt={alt}
            loading="lazy"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className={css.placeholder}>
            <ImageIcon className={css.placeholderIcon} aria-hidden="true" />
          </div>
        )}
        {children}
      </div>
    );
  },
);

ProductThumbnail.displayName = "ProductThumbnail";

ProductThumbnail.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string.isRequired,
  inset: PropTypes.bool,
  aspectRatio: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default ProductThumbnail;
